// export const loginUser = (state, { user, token }) => {
//     if (token) {
//         localStorage.setItem('token', token)
//         state.idToken = token
//     }

//     state.user = user
//     state.status = 'authenticated'
// }
import { plainAxiosInstanceAuth } from '../../api/apiMotoBoutique'

export const setUserInfo = (state, data) => {
    plainAxiosInstanceAuth.defaults.headers.common["Authorization"] = `Bearer ${data.data.token}`;
    localStorage.setItem("auth_token", data.data.token);
    // state.user = {
    //     id: data.data.user.id,
    //     name: `${data.data.user.name} ${data.data.user.last_name}`,
    //     email: data.data.user.email,
    //     rol: data.data.user.rol
    // };
    state.auth_token = data.data.token;
    state.status = 'authenticated';
}


export const setUserInfoFromToken = (state, token) => {
    // state.user = {
    //     id: data.data.user.id,
    //     name: `${data.data.user.name} ${data.data.user.last_name}`,
    //     email: data.data.user.email,
    //     rol: data.data.user.rol
    // };
    plainAxiosInstanceAuth.defaults.headers.common["Authorization"] = token;
    state.auth_token = localStorage.getItem("auth_token");
    state.status = 'authenticated';
}

export const resetUserInfo = (state) => {
    // state.user = {
    //     id: null,
    //     name: null,
    //     email: null,
    //     rol: null
    // };
    state.auth_token = null;
    state.status = 'not-authenticated';
    localStorage.removeItem("auth_token");
    plainAxiosInstanceAuth.defaults.headers.common["Authorization"] = null;
}